import { StyledButtonsGroup } from "./ButtonsGroup.styled";

export default StyledButtonsGroup;